import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import http from "@/lib/api";
import { ClipboardList, CalendarDays, Wrench, Truck, FileText, Bot, AlertTriangle, ChevronRight } from "lucide-react";

const cards = [
  { key: "new_requests", label: "Новые запросы", icon: ClipboardList, color: "text-blue-400", to: "/admin/foresporler" },
  { key: "new_bookings", label: "Новые бронирования", icon: CalendarDays, color: "text-green-400", to: "/admin/bestillinger" },
  { key: "active_repairs", label: "Активные ремонты", icon: Wrench, color: "text-amber-400", to: "/admin/reparasjoner" },
  { key: "pending_callouts", label: "Ожидающие выезды", icon: Truck, color: "text-purple-400", to: "/admin/bestillinger" },
  { key: "new_submissions", label: "Новые заявки", icon: FileText, color: "text-cyan-400", to: "/admin/innleveringer" },
  { key: "urgent_active", label: "Срочные (акутт)", icon: Truck, color: "text-red-400", to: "/admin/reparasjoner" },
  { key: "ai_new", label: "Новые AI-запросы", icon: Bot, color: "text-emerald-400", to: "/admin/ai-requests" },
  { key: "ai_follow_up", label: "Требуют ответа", icon: Bot, color: "text-amber-400", to: "/admin/ai-requests" },
];

function HealthWarning({ stats }) {
  const show = stats.email_failed_7d > 0 || stats.email_integration_active === false || stats.email_simulated_7d > 0;
  if (!show) {
    return null;
  }
  return (
    <Link to="/admin/istoriya-uvedomleniy?problems=1" data-testid="system-health-warning"
      className="group bg-red-950/40 border border-red-700 rounded-lg p-4 flex items-start gap-3 hover:bg-red-950/60 transition-colors">
      <AlertTriangle className="h-5 w-5 text-red-400 shrink-0 mt-0.5" />
      <div className="text-sm text-red-200 flex-1">
        <p className="font-semibold text-red-300">Внимание: проблемы с уведомлениями (7 дней)</p>
        {stats.email_integration_active === false && <p>Email-интеграция НЕ активна — письма клиентам не отправляются.</p>}
        {stats.email_failed_7d > 0 && <p>Не доставлено писем: {stats.email_failed_7d}. Нажмите, чтобы посмотреть причины, проверить адрес, отправить повторно или скрыть.</p>}
        {stats.email_simulated_7d > 0 && <p>Письма в режиме симуляции (не отправлены по-настоящему): {stats.email_simulated_7d}.</p>}
      </div>
      <ChevronRight className="h-5 w-5 text-red-300 self-center group-hover:translate-x-0.5 transition-transform" />
    </Link>
  );
}

export default function AdminDashboard() {
  const [stats, setStats] = useState({});

  useEffect(() => { http.get("/v1/admin/dashboard").then((r) => setStats(r.data)).catch(() => {}); }, []);

  return (
    <div className="space-y-6" data-testid="admin-dashboard">
      <h1 className="text-2xl font-bold text-white">Панель управления</h1>
      <HealthWarning stats={stats} />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map((c) => {
          const Icon = c.icon;
          return (
            <Link key={c.key} to={c.to} data-testid={`dash-card-${c.key}`}
              className="bg-slate-800 border border-slate-700 rounded-lg p-5 hover:border-blue-500 hover:bg-slate-700/60 transition-colors">
              <div className="flex items-center justify-between mb-2"><Icon className={`h-6 w-6 ${c.color}`} /><span className="text-3xl font-bold text-white">{stats[c.key] ?? 0}</span></div>
              <p className="text-sm text-slate-400 flex items-center justify-between">{c.label}<ChevronRight className="h-4 w-4 text-slate-500" /></p>
            </Link>
          );
        })}
      </div>
      <div className="bg-slate-800 border border-slate-700 rounded-lg p-5 text-slate-300 text-sm">
        <p>Добро пожаловать в панель управления Bergen Kaffemaskin- og Teknikk Service. Нажмите на карточку, чтобы перейти к записям, или используйте меню слева.</p>
      </div>
    </div>
  );
}
